export function trackZipcodeEntered(zipcode, page, country, area_opened) {
  window?.rudderanalytics?.track("Zipcode Entered", {
    zipcode,
    page,
    country,
    area_opened,
  });
}
